/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import styles from "./NoteFinderPageOverlayTie.module.scss"
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {
    NoteFinderPageOverlayTie_Tie$data
} from "ui/feature/root/note-select/__generated__/NoteFinderPageOverlayTie_Tie.graphql";

interface Props {
    tie: NoteFinderPageOverlayTie_Tie$data;
    pageWidth: number;
    pageHeight: number;
}

const NoteFinderPageOverlayTie: React.FC<Props> = ({tie, pageWidth, pageHeight}) => {

    const leftStart = React.useMemo(() => {
        return `${(tie.start_x / pageWidth) * 100}%`;
    }, [tie.start_x, pageWidth]);

    const topStart = React.useMemo(() => {
        return `${(tie.start_y / pageHeight) * 100}%`;
    }, [tie.start_y, pageHeight]);

    const leftEnd = React.useMemo(() => {
        return `${(tie.end_x / pageWidth) * 100}%`;
    }, [tie.end_x, pageWidth]);

    const topEnd = React.useMemo(() => {
        return `${(tie.end_y / pageHeight) * 100}%`;
    }, [tie.end_y, pageHeight]);

    return (
        <>
            <div className={styles.overlayContainer} style={{
                left: leftStart,
                top: topStart
            }}/>
            <div className={styles.overlayContainer} style={{
                left: leftEnd,
                top: topEnd
            }}/>
        </>
    );
}

export default createFragmentContainer(NoteFinderPageOverlayTie, {
    tie: graphql`
    fragment NoteFinderPageOverlayTie_Tie on MusicParseStepDataTieFinderTie {
        start_x
        start_y
        end_x
        end_y
        id
    }
    `
});
